<template>
    <router-view></router-view>
</template>
<script>
export default {
    
}
</script>
<style>
    .card {
        min-height: inherit !important;
    }

    .card__no_padding, .tab__no_padding{
        padding: 0 !important;
    }

    .card__bordered{
        border: 1px solid #e5e5e5 !important;
    }

    .card__bordered .card-header{
        border-bottom: 1px solid #e5e5e5 !important;
    }

    .card__no_shadow{
        box-shadow: none !important;
    }

    .tab__header_white .card-header{
        background: #fff !important;
    }

    .table .thead-tab th {
        background: #e9e9e926;
        border: 1px solid #e5e5e5;
        text-align: center;
        vertical-align: middle;
        font-weight: 600;
    }

    .table-tab .table-tab__input {
        padding: 0 !important;
    }

    .table-tab__input fieldset {
        margin-bottom: 0;
    }

    .table-tab__input .custom-select, .table-tab__input .form-control {
        border: none;
    }
</style>